import React from 'react';
import {
  AddAccompanyingPage,
  AddAgtpepPage,
  AddBusPartnerPage,
  AddCreditPage,
  AddEmployeePage,
  AddGoodwillPage,
  AddHybridPage,
  AddMarketingPage,
  AddRebookingPage,
  AddUxPage,
} from '../pages/VoucherTemplates';
import { withRoleProtection } from '../components/Auth';
import { ROLES } from '../types/Roles';

// Create protected components using HOC
const ProtectedAddMarketingPage = withRoleProtection(AddMarketingPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_MARKETING_VOUCHER],
});

const ProtectedAddRebookingPage = withRoleProtection(AddRebookingPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_GOODWILL_VOUCHER],
});

const ProtectedAddGoodwillPage = withRoleProtection(AddGoodwillPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_GOODWILL_VOUCHER],
});

const ProtectedAddAccompanyingPage = withRoleProtection(AddAccompanyingPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_ACCOMPANYING_PERSON_VOUCHER],
});

const ProtectedAddAgtpepPage = withRoleProtection(AddAgtpepPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
});

const ProtectedAddUxPage = withRoleProtection(AddUxPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
});

const ProtectedAddBusPartnerPage = withRoleProtection(AddBusPartnerPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
});

const ProtectedAddEmployeePage = withRoleProtection(AddEmployeePage, {
  requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
});

const ProtectedAddCreditPage = withRoleProtection(AddCreditPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
});

const ProtectedAddHybridPage = withRoleProtection(AddHybridPage, {
  requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
});

export interface AddVoucherTemplatesType {
  name: string;
  path: string;
  element: React.ReactNode;
  type:
    | 'marketing'
    | 'customer-service'
    | 'finance'
    | 'ux-research'
    | 'operations'
    | 'flix-benefit';
  requiredRoles: string[];
}

const AddVoucherTemplates: AddVoucherTemplatesType[] = [
  {
    name: 'Marketing voucher',
    path: '/add/marketing-voucher',
    element: <ProtectedAddMarketingPage />,
    type: 'marketing',
    requiredRoles: [ROLES.ROLE_MANAGE_MARKETING_VOUCHER],
  },
  {
    name: 'Rebooking voucher',
    path: '/add/rebooking-voucher',
    element: <ProtectedAddRebookingPage />,
    type: 'customer-service',
    requiredRoles: [ROLES.ROLE_MANAGE_GOODWILL_VOUCHER],
  },
  {
    name: 'Goodwill voucher',
    path: '/add/goodwill-voucher',
    element: <ProtectedAddGoodwillPage />,
    type: 'customer-service',
    requiredRoles: [ROLES.ROLE_MANAGE_GOODWILL_VOUCHER],
  },
  {
    name: 'Accompanying voucher',
    path: '/add/accompanying-voucher',
    element: <ProtectedAddAccompanyingPage />,
    type: 'customer-service',
    requiredRoles: [ROLES.ROLE_MANAGE_ACCOMPANYING_PERSON_VOUCHER],
  },
  {
    name: 'Partner agency voucher',
    path: '/add/partner-agency-voucher',
    element: <ProtectedAddAgtpepPage />,
    type: 'customer-service',
    requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
  },
  {
    name: 'UX voucher',
    path: '/add/ux-voucher',
    element: <ProtectedAddUxPage />,
    type: 'ux-research',
    requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
  },
  {
    name: 'Bus partner voucher',
    path: '/add/bus-partner-voucher',
    element: <ProtectedAddBusPartnerPage />,
    type: 'operations',
    requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
  },
  {
    name: 'Employee voucher',
    path: '/add/employee-voucher',
    element: <ProtectedAddEmployeePage />,
    type: 'flix-benefit',
    requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
  },
  {
    name: 'Credit voucher',
    path: '/add/credit-voucher',
    element: <ProtectedAddCreditPage />,
    type: 'finance',
    requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
  },
  {
    name: 'Hybrid/free ride voucher',
    path: '/add/hybrid-free-ride-voucher',
    element: <ProtectedAddHybridPage />,
    type: 'finance',
    requiredRoles: [ROLES.ROLE_MANAGE_AGTPEP_VOUCHER],
  },
];

export default AddVoucherTemplates;
